/*
 * @Description: 登录相关页面接口
 * @Author: gao shuai
 * @Date: 2020-06-06 14:50:14
 * @LastEditTime: 2020-06-23 14:19:15
 * @LastEditors: gao shuai
 */

import api from '../services/api';

// 缓存租户基础信息
let tenantBaseInfoCache = null;
let tenantBaseInfoPromise = null;

export default {

  // 资费列表
  async rechargeList(params) {
    return api({
      url: '/api/About/GetTenantPostagesAsync',
      method: 'get',
      params: params
    });
  },
  // 获取租户基础信息（合并了联系我们和footer信息）- 带缓存
  async getTenantBaseInfo(params) {
    // 如果已有缓存，直接返回
    if (tenantBaseInfoCache) {
      return Promise.resolve(tenantBaseInfoCache);
    }
    
    // 如果正在请求中，返回同一个Promise避免重复请求
    if (tenantBaseInfoPromise) {
      return tenantBaseInfoPromise;
    }
    
    // 发起新请求
    tenantBaseInfoPromise = api({
      url: '/api/About/GetTenantBaseInfoAsync',
      method: 'get',
      params: params
    }).then(response => {
      // 缓存响应数据
      tenantBaseInfoCache = response;
      tenantBaseInfoPromise = null; // 清除请求Promise
      return response;
    }).catch(error => {
      tenantBaseInfoPromise = null; // 请求失败时清除Promise
      throw error;
    });
    
    return tenantBaseInfoPromise;
  },
  // 清除租户基础信息缓存（在需要强制刷新时调用）
  clearTenantBaseInfoCache() {
    tenantBaseInfoCache = null;
    tenantBaseInfoPromise = null;
  },
  // 注册
  async register(params) {
    return api({
      url: '/api/Register/UserRegister',
      method: 'post',
      data: params
    });
  },
  // 获取公告信息
  async getNotice(params) {
    return api({
      url: '/api/About/GetNoticeList',
      method: 'get',
      params: params
    });
  },
  // 获取随机验证码
  async getRandomCode(params) {
    return api({
      url: '/api/Register/createcode',
      method: 'get',
      params: params
    });
  }
};

// 导出缓存清除方法，供其他地方使用
export const clearTenantBaseInfoCache = () => {
  tenantBaseInfoCache = null;
  tenantBaseInfoPromise = null;
};
